import type { BaseNode, RelayEdges } from '@/types/graphql'
import type { DynamicColumnType } from '.'

export enum ColumnNames {
  DATE = 'date',
  TYPE = 'type',
  REGNR = 'regNr',
  START_TIME_LOCATION = 'dayStartTimeAndLocation',
  END_TIME_LOCATION = 'dayEndTimeAndLocation',
  START_TIME = 'dayStartTime',
  END_TIME = 'dayEndTime',
  START_LOCATION = 'dayStartLocation',
  END_LOCATION = 'dayEndLocation',
  TOTAL_WORK = 'timeTotalWork',
  DRIVING = 'timeDriving',
  OVERTIME = 'timeOvertime',
  AVAILABILITY = 'timeAvailability',
  PAUSE = 'timePause',
  OTHER_WORK = 'timeOtherWork',
  REST = 'timeRest',
  STATUS = 'dataStatus',
  APPROVED = 'approved',
  SALARY_ID = 'salaryId',
  SALARY_NAME = 'salaryName',
  DIET = 'diet',
  COMMENT = 'comment',
  ADDONS = 'addons',
  SALARY_DAY = 'salaryDay',
  DEPARTMENT = 'department',
  FACILITY = 'facility',
  EMPLOYEE_GROUP = 'employeeGroup',
  APPROVED_BY_DRIVER = 'approvedByDriver',
  APPROVED_BY_MANAGER = 'approvedByManager',
  TRANSFERRED_TO_FLEX = 'transferredToFlex',
}

export enum SummationColumnNames {
  TOTAL_WORK = 'timeWorkTotal',
  DRIVING = 'timeDriving',
  OVERTIME = 'timeOvertime',
  AVAILABILITY = 'timeAvailability',
}

export interface DynamicColumnNode extends BaseNode {
  __typename: 'DynamicColumnNode'
  id: string
  name: ColumnNames
  displayName: string
  enabled: boolean
  inExport: boolean
  columnType: DynamicColumnType
  order: number
}

export interface ActivitiesWithReceiptCoolumnNode extends DynamicColumnNode {
  approved: boolean
}

export interface AllDynamicColumnsQuery<
  T extends DynamicColumnNode = DynamicColumnNode,
> {
  allDynamicColumns: RelayEdges<T>
}
export interface AllDynamicColumnsQueryVariables {
  moduleName: string
  enabled?: boolean
  /** Which table inside the module. Omitted for a module with a single table. */
  table?: string
}

export interface PatchDynamicColumnMutation<
  T extends DynamicColumnNode = DynamicColumnNode,
> {
  patchDynamicColumn: Pick<T, 'id'>
}

export interface PatchDynamicColumnMutationVariables {
  id: string
  input: {
    name?: string
    displayName?: string
    enabled?: boolean
    inExport?: boolean
    order?: number
  }
}
